import { Box, Flex } from 'components/Box';
import { Text } from 'components/Text';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import HeroImage from 'assets/Hero/HeroImage.svg';
import HeroBackground from 'assets/Hero/HeroBackground.svg';

export const BannerBody = styled.div`
    background: radial-gradient(74.5% 111.75% at 49.73% 106.8%,#3B0864 0%,#200942 39%,#0B0B28 77%,#030B1E 100%);
`
export const ContainerBackground = styled.div`
    background-image: url(${HeroBackground});
    background-repeat: no-repeat;
    background-size: cover;
`
export const ContainerWrapper = styled.div`
    background-repeat: no-repeat;
    background-position: top 100% center;
    ${({ theme }) => theme.mediaQueries.xs} {
        height: 350px;
        background-image: none;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        background-image: url(${HeroImage});
        height: 830px;
    }
`
export const ContainerBanner = styled(Container)`
    padding-top: 100px;
`
export const BoxWrapper = styled(Box)`
    display:flex; 
    justify-content:center; 
    flex-direction:column;
    width:70%;
    margin: 0 auto;

    ${({ theme }) => theme.mediaQueries.sm} {
		width:100%;
		align-items:center;
    }
    ${({ theme }) => theme.mediaQueries.md} {
		width:75%;
		align-items: normal;
    }
`
export const HeroBodySection = styled(Box)`
    text-align: center;

    ${({ theme }) => theme.mediaQueries.xs} {
        .BannerLogoWidthMobile {
		    width: 300px;
	    }
    }
    ${({ theme }) => theme.mediaQueries.sm} {
       .BannerLogoWidthMobile {
		    width: unset;
	    }
    }
`
export const BuildPlayFontSize = styled(Text)`
    font-size: 20px;
    text-align: center;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
`

export const BannerImageBox = styled(Box)`
    width: 100%;
    
    ${({ theme }) => theme.mediaQueries.xs} {
        justify-content: center;
        display: flex;

        & img{
            width: 80%;
        }
    }
    ${({ theme }) => theme.mediaQueries.md} {
        & img{
            width: 100%;
        }
    }
`

export const BannerTextGameStyle = styled(Text)`
	font-size: 56px;
	line-height: 81px;
	color:  ${(props) => props.theme.colors.primary};
`

export const BannerTextGameStyleTwo = styled(Text)`
	color:  ${(props) => props.theme.colors.primary};

    ${({ theme }) => theme.mediaQueries.xs} {
        font-size: 24px;
	    line-height: 31px;
    }
    ${({ theme }) => theme.mediaQueries.md} {
       	font-size: 56px;
	    line-height: 81px;
    }
`

export const BannerGamesBody = styled(BoxWrapper)`
    ${({ theme }) => theme.mediaQueries.xs} {
        width: 100%;
        text-align: center;
    }
    ${({ theme }) => theme.mediaQueries.md} {
        padding-top: 40px;
    }
`

export const BannerTextGameTextStyle = styled(Text)`
	color:  ${(props) => props.theme.colors.gamefiSubHeadingColor};
    ${({ theme }) => theme.mediaQueries.xs} {
        font-size: 18px;
	    line-height: 26px;
        margin: 15px auto;
    }
    ${({ theme }) => theme.mediaQueries.md} {
       	font-size: 24px;
	    line-height: 1.5;
        margin: 0;
    }
`
export const BannerBox = styled(Box)`
	margin: 50px auto;
    text-align: center;
    .BannerImg{
        ${({ theme }) => theme.mediaQueries.xs} {
            width: 100%;
            height: 130px;
        }
        ${({ theme }) => theme.mediaQueries.md} {
            width: 1200px;
            height: 436px;
        }
    }
    `

export const GamefiMainHeadingStyle = styled.div`
	font-size: 36px;
	line-height: 52px;
	color:  ${(props) => props.theme.colors.primary};
	text-align: center;
`

export const GamefiSubHeadingStyle = styled.div`
	font-weight: 500;
	font-size: 20px;
	line-height: 29px;
	color: ${(props) => props.theme.colors.gamefiSubHeadingColor};
	text-align:center;
	padding-top: 15px;
`
export const BannerTextStyling = styled(Flex)`
    display: flex;
    align-items: center;
    padding: 15px 0px;
`
export const HeroCircleStyle = styled(Box)`
    background-image: url("./newAssets/Hero/HeroBG-1.svg");
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    background: radial-gradient(74.5% 111.75% at 49.73% 106.8%, #3B0864 0%, #200942 39%, #0B0B28 77%, #030B1E 100%);
`